import { SquarePlay } from 'lucide-react';

import { definePanel } from '@/app/definePanel';

export default definePanel({
    id: 'camera_view',
    title: 'View',
    icon: SquarePlay,
    width: { min: 384, default: 672, max: Infinity, fill: true },
    modes: ['view', 'settings'],
    themes: 'dark', // forced dark per Figma
    hasVideo: true,
    isHeaderless: true, // header overlays the video; we render it ourselves
    shouldClip: true, // clip the full-bleed video to the rounded corners
    // Tabs whose UX is built around the live preview (motion overlay grid, line
    // drawing): switching into one of these auto-opens the preview if it was
    // closed and the stage can show it beside the form (see AppShell). It never
    // changes width rules.
    previewTabs: ['motion', 'agent:line_crossing'],
    order: 100, // rightmost fill surface
    // Live WebRTC must not keep streaming behind another panel — unmount when
    // the row has no room for it (the pooled connection makes the remount cheap).
    shouldKeepMounted: false,
    // When switching to settings while watching a camera, auto-open its
    // settings panel beside the live view. No reverse: camera_settings is
    // settings-only, so the view-mode switch just closes it.
    autoOpenIds: ['camera_settings'],
    // Mutual exclusions live in src/app/exclusions.ts (camera_view vs the
    // other-settings lists + servers).
    // cameraId, t and layoutId live in the URL — and only while a panel
    // declaring them is open — so a shared link opens the same camera or the same
    // layout. The ad-hoc scene, the command the shell hands it and every display
    // preference stay in the local props: one viewer's choices are not part of the link.
    // settingsTab is camera_settings' URL prop and arrives as a direct prop from
    // PanelStage.
    urlSyncedProps: ['cameraId', 't', 'layoutId'],
    hasNavButton: false,
});
